import { IRootState } from './index';
import { IRegisterState } from './register.types';

export const selectRegister = ({ register }: IRootState): IRegisterState => register;
